import { useFormContext } from '@/providers'
import { UserTypes } from '@/types/user-profile'
import { find, path, pipe, prop, propEq } from 'ramda'

export interface User {
  companies: Array<{
    companyId: string
    userType: UserTypes
  }>
}

export const isMd = (companyId: string, user: User): boolean =>
  pipe(
    prop('companies'),
    find(propEq(companyId, 'companyId')),
    path(['userType', 'MD']),
  )(user) as boolean

interface FormContext {
  customValidate: (params: {
    fields?: (string | number)[]
    onSuccess: () => void
    onFail?: () => void
  }) => Promise<void>
}

export const useValidateCheckoutStep = (
  onNext: () => void,
  fields?: string[],
): (() => void) => {
  const { customValidate } = useFormContext() as FormContext
  const handleNext = () => {
    customValidate({
      fields,
      onSuccess: onNext,
    })
  }

  return handleNext
}
